import getAssetUrl from 'utils/getAssetUrl';

export const tosLink = getAssetUrl(
  '/assets/policies/TOS_Version_2026_REV_GV_16.04.2026.pdf'
);

export const privacyPolicyLink = 'https://www.iubenda.com/privacy-policy/12034082/legal';
